<template>
    <div class="modeling-popover-wrapper">
        <div>{{ statusState }}</div>
        <el-popover placement="top" :visible-arrow="false" :width="200" trigger="hover" v-show="statusState !== '无'">
            <div slot="reference">
                <img class="icon-img" src="../../../../assets/images/icon/icon_info.png">
            </div>
            <div>
                <div class="modeling-title">建模详情</div>
                <div class="modeling-content">
                    <span>一体机 主屏幕</span>
                    <span :style="statusColor('dianaModelStatus')">
                        {{ modelingStatus('dianaModelStatus') }}
                    </span>
                </div>
                <div class="modeling-content">
                    <span>一体机 运动相机</span>
                    <span :style="statusColor('endPointModelStatus')">
                        {{ modelingStatus('endPointModelStatus') }}
                    </span>
                </div>
                <div class="modeling-content">
                    <span>坐位体前屈</span>
                    <span :style="statusColor('sitAndReachModelStatus')">
                        {{ modelingStatus('sitAndReachModelStatus') }}
                    </span>
                </div>
                <div class="modeling-content">
                    <span>体检一体机</span>
                    <span :style="statusColor('examDianaModelStatus')">
                        {{ modelingStatus('examDianaModelStatus') }}
                    </span>
                </div>
                <div class="modeling-content">
                    <span>超脑</span>
                    <span :style="statusColor('hyperbrainModelStatus')">
                        {{ modelingStatus('hyperbrainModelStatus') }}
                    </span>
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: ['dataSource'],
    computed: {
        // 状态
        statusState() {
            if (!this.dataSource) {
                return '无';
            }
            const diana = this.dataSource.dianaModelStatus;
            const end = this.dataSource.endPointModelStatus;
            const sit = this.dataSource.sitAndReachModelStatus;
            const exam = this.dataSource.examDianaModelStatus;
            const brain = this.dataSource.hyperbrainModelStatus || 0;
            if (diana == 0 && end == 0 && sit == 0 && exam == 0 && brain == 0) {
                return '无';
            }
            if (diana == 2 || end == 2 || sit == 2 || exam == 2 || brain == 2) {
                return '失败'
            }
            return '成功'
        },
    },
    methods: {
        // 状态
        modelingStatus(statusName) {
            const status = this.dataSource ? this.dataSource[statusName] : 0;
            if (!status || status == 0) {
                return '无';
            } else if (status == 1) {
                return '成功';
            } else if (status == 2) {
                return '失败';
            }
            return '';
        },
        // 状态颜色
        statusColor(statusName) {
            const status = this.dataSource ? this.dataSource[statusName] : 0;
            if (!status || status == 0) {
                return { color: '#999999' };
            } else if (status == 1) {
                return { color: '#405FFF' };
            } else if (status == 2) {
                return { color: '#FF4444' };
            }
            return '';
        }
    }
}
</script>

<style scoped>
.modeling-popover-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.icon-img {
    margin-top: 4px;
    margin-left: 4px;
    width: 18px;
    height: 18px;
}

.modeling-title {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
}

.modeling-content {
    display: flex;
    flex-direction: row;
    height: 30px;
    font-size: 14px;
    color: #666666;
}

.modeling-content span:nth-child(2) {
    margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// ModelPopover.vue?1e4b7b2e